export enum TokenEnum {
    ID_TOKEN = "idToken",
    ACCESS_TOKEN = "accessToken"
}

export enum UserSettings {
    DARKMODE = 'dark-mode',
    MAP_OVERLAP = 'map-overlap',
    MARKER_TEXT = 'map-marker-text',
    SHOW_MAP_LIST = 'show-map-list'
}